<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Have you had a test for Lipoprotein (a) [Lp(a)]? <br />
      If yes, what was your highest score?
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadTest">
      <b-form-radio v-model="survey.bloodBiochemistry.lipoproteinA.hadTest" name="test"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.lipoproteinA.hadTest" name="test"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
    <div v-if="hadTest" class="page-buttons">
      <v-form-group :validator="$v.testScore" label="Highest score">
        <form-input-decimal v-model="survey.bloodBiochemistry.lipoproteinA.testScore" placeholder="Score" precision="1" />
      </v-form-group>
      <v-form-group class="card-selector" :validator="$v.unitOfMesure">
        <b-form-radio v-model="survey.bloodBiochemistry.lipoproteinA.unitOfMesure" name="measure"
                      :value=measureType.MilligramsPerDeciliter>
          mg/dL
        </b-form-radio>
        <b-form-radio v-model="survey.bloodBiochemistry.lipoproteinA.unitOfMesure" name="measure"
                      :value=measureType.NanomolesPerLitre>
          nmol/L
        </b-form-radio>
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, requiredIf, between, decimal } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import measureType from 'enums/measure-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        measureType: measureType
      }
    },

    validations: {
      hadTest: {
        required
      },
      testScore: {
        required: requiredIf(function () { return this.hadTest; }),
        between: between(0, 600),
        decimal
      },
      unitOfMesure: {
        required: requiredIf(function () { return this.hadTest; })
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadTest() { return this.survey.bloodBiochemistry.lipoproteinA.hadTest; },
      testScore() { return this.survey.bloodBiochemistry.lipoproteinA.testScore; },
      unitOfMesure() { return this.survey.bloodBiochemistry.lipoproteinA.unitOfMesure; }
    }
  };
</script>